import { render, staticRenderFns } from "./CardReceive.vue?vue&type=template&id=d6658264&scoped=true"
import script from "./CardReceive.vue?vue&type=script&lang=js"
export * from "./CardReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6658264",
  null
  
)

export default component.exports